module.exports = __webpack_public_path__ + "static/media/telegram.e0c1793d.svg";